<script>
export default {
  name: 'PayInvoice',
  props: {
    options: {
      required: true,
    },
  },
  data () {
    return {
      card: null,
      stripe: null,
      cardReady: false,
      isLoading: false,
    }
  },
  methods: {
    async onSubmit() {
      if (!this.cardReady) return this.$toast({copy: 'Complete card input', class: 'alert'})

      this.isLoading = true
      // validate card
      let card
      try {
        card = (await this.stripe.createToken(this.card)).token
      } catch (e) {
        this.$toast({
          copy: 'Problem with card',
          class: 'alert',
        })
        this.isLoading = false
        return console.log(e)
      }

      try {
        await this.$HTTP({
          method: 'post',
          uri: `users/${this.options.guardian.id}/pay-invoice`,
          body: {
            invoice: this.options.invoice,
            guardian: this.options.guardian,
            card,
            origin: location.origin,
          },
          secure: false,
        })
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: e.body.message,
          class: 'alert'
        })
        this.isLoading = false
        return
      }

      this.$toast({copy: 'Thank you for your payment'})
      this.$modals.hide('pay-invoice')
      const successFunc = this.options.onSuccess
      successFunc()
      
    },
    setUpStripeElement () {
      // eslint-disable-next-line
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
      const elements = this.stripe.elements()

      this.card = elements.create('card')

      this.card.on('change', (event) => {
        this.cardReady = event.complete
      })

      this.card.mount('#card-element')
    },
  },
  mounted () {
    this.setUpStripeElement()
  },
}
</script>

<template lang="pug">
  #invoice-main.modal-main
    .invoice-container.modal-container
      .title Pay Invoice
      .content
        .description 
          .amount Amount: 
            b ${{options.invoice.amount}}
          .date Date: {{new Date(options.invoice.created).toLocaleDateString()}}
          .message {{options.invoice.message}}
      .content.payment
        .content-title Credit card
        .explain
          | Enter the information for the credit card you'd like to use to pay this invoice.
        .card-holder
          #card-element
      .action
        .button.minor(
          @click='$modals.hide(`pay-invoice`)'
        ) Cancel
        span
        .button.major(
          v-if='isLoading'
        ) 
          i.material-icons.spin-me refresh
        .button.major(
          v-else
          @click='onSubmit'
        ) Pay Invoice
 </template>

 <style lang="sass" scoped>
  .invoice-container
    .content
      .description
        .message
          margin-top: 0.5rem
 </style>